import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import CinematicBackground from "@/components/CinematicBackground";
import { useLang } from "@/i18n/LanguageContext";

export default function LanguageSelect() {
  const navigate = useNavigate();
  const { setLang } = useLang();

  const choose = (l) => { setLang(l); setTimeout(() => navigate("/app"), 360); };

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden px-6 py-12" data-testid="language-select-page">
      <CinematicBackground dense />

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="relative z-10 w-full max-w-md flex flex-col items-center">
        <div className="w-16 h-16 rounded-2xl glass glass-blue flex items-center justify-center mb-6">
          <i className="fa-solid fa-language text-gold text-2xl" />
        </div>
        <h1 className="font-display text-3xl gold-gradient-text mb-1 text-center" dir="rtl">اختر لغة التطبيق</h1>
        <p className="text-slate-300 text-base mb-10 text-center" dir="ltr">Choose Application Language</p>

        <div className="w-full space-y-5">
          <LangCard
            testId="lang-card-ar"
            flag="🇮🇶"
            title="العربية"
            sub="Arabic Version"
            desc="للجامعات والطلبة والباحثين الناطقين باللغة العربية"
            accent="#d9b46a"
            dir="rtl"
            onClick={() => choose("ar")}
            delay={0.1}
          />
          <LangCard
            testId="lang-card-en"
            flag="🇬🇧"
            title="English"
            sub="International Version"
            desc="For international students, universities and researchers."
            accent="#4ea8ff"
            dir="ltr"
            onClick={() => choose("en")}
            delay={0.22}
          />
        </div>

        <p className="text-[11px] text-slate-500 mt-10 text-center">© 2026 Mohanad Khaleel Ibrahim</p>
      </motion.div>
    </div>
  );
}

function LangCard({ testId, flag, title, sub, desc, accent, dir, onClick, delay }) {
  return (
    <motion.button
      data-testid={testId}
      onClick={onClick}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5 }}
      whileHover={{ scale: 1.02, y: -3 }}
      whileTap={{ scale: 0.98 }}
      dir={dir}
      className="w-full glass glass-blue rounded-3xl p-5 flex items-center gap-4 text-right relative overflow-hidden"
      style={{ border: `1px solid ${accent}66`, boxShadow: `0 0 28px ${accent}22` }}
    >
      <div className="absolute -left-8 -bottom-8 w-28 h-28 rounded-full" style={{ background: `radial-gradient(circle, ${accent}22, transparent 70%)` }} />
      <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-4xl shrink-0" style={{ background: "rgba(255,255,255,0.05)", border: `1px solid ${accent}55` }}>
        <span>{flag}</span>
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <h3 className="font-display text-2xl" style={{ color: accent }}>{title}</h3>
          <i className="fa-solid fa-earth-americas text-sm" style={{ color: accent }} />
        </div>
        <p className="text-xs text-slate-300 mb-1.5">{sub}</p>
        <p className="text-[12px] text-slate-400 leading-relaxed">{desc}</p>
      </div>
      <i className={`fa-solid ${dir === "rtl" ? "fa-chevron-left" : "fa-chevron-right"} text-slate-500`} />
    </motion.button>
  );
}
